// The words of the toast that follows a day's sync run in the background
// (2026-10-19: "it would be better to have a toast when syncing"). Pure, so
// the messages are tested without the toast provider or the store. index.tsx
// shows the toast as the background sync starts, updates it from the import
// store's changes, and hands it to the new-game toast when games came in.
import type { SyncState } from '@chess/api-sync';

/** How long "No new games since the last sync" stays up. */
export const NO_NEWS_TOAST_MS = 4000;
/** How long "Could not reach chess.com" stays up. */
export const FAILED_TOAST_MS = 10_000;

export interface SyncToastText {
  message: string;
  kind: 'info' | 'warning';
  /** Set once the import is over and nothing else follows: the toast closes after this long. */
  closeAfterMs?: number;
}

/**
 * The toast's text for where the sync stands. `undefined` once the import
 * brought in new games: the new-game toast ("3 new games · the latest vs X
 * · reading it…", with its Review button) takes over from this one.
 */
export function syncToastMessage(state: Pick<SyncState, 'phase' | 'month' | 'imported' | 'error'>): SyncToastText | undefined {
  switch (state.phase) {
    case 'idle':
      return { message: 'Checking chess.com for new games…', kind: 'info' };
    case 'importing':
      return { message: state.month ? `Reading ${state.month}…` : 'Checking chess.com for new games…', kind: 'info' };
    case 'done':
      if (state.imported) return undefined;
      return { message: 'No new games since the last sync', kind: 'info', closeAfterMs: NO_NEWS_TOAST_MS };
    case 'error':
      return { message: `Could not reach chess.com: ${state.error ?? 'unknown error'}`, kind: 'warning', closeAfterMs: FAILED_TOAST_MS };
  }
}
